import React, { useMemo } from 'react';

import { buildMatcher } from '../utils/richTranscript';

interface LogViewProps {
  text: string | undefined;
  isLoading: boolean;
  hasLog: boolean;
  query: string;
}

/** Lines of `text` matching `query` (regex when valid, else plain text), case-insensitive. */
export function filterLogLines(text: string, query: string): string[] {
  const lines = text.split('\n');
  if (!query) return lines;
  const matches = buildMatcher(query);
  return lines.filter(l => matches(l));
}

/** The agent's session log for the call, filtered by the page search. */
export const LogView: React.FC<LogViewProps> = ({ text, isLoading, hasLog, query }) => {
  const lines = useMemo(() => (text ? filterLogLines(text, query) : []), [text, query]);

  if (!hasLog)
    return <p className="p-4 text-sm text-muted-foreground">No session log for this call.</p>;
  if (isLoading) return <p className="p-4 text-sm text-muted-foreground">Loading log…</p>;
  if (lines.length === 0)
    return <p className="p-4 text-sm text-muted-foreground">No log lines match.</p>;

  return (
    <pre className="whitespace-pre-wrap break-words p-2 font-mono text-xs">{lines.join('\n')}</pre>
  );
};
